import React from 'react';
import './UpdateBlockScreen.css';

const UpdateBlockScreen = ({ updateInfo }) => {
  const { status, version, percent, bytesPerSecond, transferred, total, message } = updateInfo;

  const formatBytes = (bytes) => {
    if (!bytes) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  return (
    <div className="update-block-overlay">
      <div className="update-block-card">
        <div className="update-block-icon">
          <svg viewBox="0 0 24 24" width="56" height="56" fill="none" stroke="#0d6efd" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </div>

        <h1 className="update-block-title">
          {status === 'available' && 'Nueva version disponible'}
          {status === 'downloading' && 'Descargando actualizacion...'}
          {status === 'downloaded' && 'Instalando actualizacion...'}
          {status === 'error' && 'Error de actualizacion'}
        </h1>

        {version && (
          <p className="update-block-version">
            Version {version}
          </p>
        )}

        {status === 'downloading' && (
          <div className="update-progress-container">
            <div className="update-progress-bar">
              <div
                className="update-progress-fill"
                style={{ width: `${percent || 0}%` }}
              />
            </div>
            <div className="update-progress-info">
              <span>{percent || 0}%</span>
              <span>{formatBytes(transferred)} / {formatBytes(total)}</span>
              <span>{formatBytes(bytesPerSecond)}/s</span>
            </div>
          </div>
        )}

        {status === 'downloaded' && (
          <p className="update-block-installing">
            La aplicacion se reiniciara automaticamente en unos segundos...
          </p>
        )}

        {status === 'available' && (
          <p className="update-block-subtitle">
            Preparando descarga...
          </p>
        )}

        {status === 'error' && (
          <div className="update-block-error">
            <p>{message || 'Error desconocido al actualizar'}</p>
            <p className="update-block-hint">Verifique su conexion a internet e intente de nuevo.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpdateBlockScreen;
